import { render } from "./IngredientCheckerPromo.vue?vue&type=template&id=2b6dbc9e&scoped=true"
import script from "./IngredientCheckerPromo.vue?vue&type=script&lang=js"
export * from "./IngredientCheckerPromo.vue?vue&type=script&lang=js"

import "./IngredientCheckerPromo.vue?vue&type=style&index=0&id=2b6dbc9e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6dbc9e"]])

export default __exports__